module.exports = __webpack_public_path__ + "img/plus-square.fa8df262.svg";